import { useEffect, useState } from "react";
import {
  TableContainer, Tr, Td, Th, Table, Thead,
  Input, FormLabel, FormControl, ModalCloseButton,
  Tbody, Button,
  ModalFooter,
  Icon, Box, Heading, useToast, Text, HStack, Modal, ModalOverlay, ModalContent, ModalHeader, CloseButton, ModalBody, Tooltip,
} from "@chakra-ui/react";

//import { MdEditDocument, MdNote, MdSearch, MdEdit, } from "react-icons/md";
import { SearchIcon } from '@chakra-ui/icons';
import { react_api } from "../config";
import { HTTP_STATUS_CODES } from "../GrinsCostant";
import { MdPublic, MdTransform } from "react-icons/md";
import createAxiosInstance from "../interceptors/useAxiosInterceptors"
import { useSession } from '../SessionContext';
import { useNavigate } from "react-router-dom";
import logout from "../services/authService";
import { convertUtcToLocal } from "../services/utils";
import { useTranslation } from "react-i18next";
import { useDisclosure } from "@chakra-ui/react";
import { BsFillSendPlusFill } from "react-icons/bs";
import SpinnerXL from "./SpinnerXL";
/*
  Carica i risultati in una tabella ogni volta che viene caricata la pagina (useEffect) interrogando l'endpoint con
  l'invio di un json contente il token di identificaione, l'username dellutente e una costante caseType per indicare al backend
  di quale chiamata si tratta e quali paremetri deve inviarci. Per consultare i case type consultare il file CaseTypeConstant.js  
  */




export default function Risultati() {
  const [publishResultPayload, setPublishResultPayload] = useState({})

  const [catalog, setCatalog] = useState([]);
  const toast = useToast();
  const [message, setMessage] = useState("");

  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const { t } = useTranslation();
  const { updateSessionData, clearSessionData } = useSession();
  const { isOpen: isPublishResultModalOpen, onOpen: onPublishResultModalOpen, onClose: onPublishResultModalClose } = useDisclosure();

  const navigate = useNavigate();


  const axiosInstance = createAxiosInstance(async (axiosInstance) => {

    logout(t, clearSessionData, navigate, toast, axiosInstance)
  });

  const [keys, setKeys] = useState([]);
  const [resultList, setResultList] = useState([]);
  const [resultTableName, setResultTableName] = useState("");
  const [isResultModalOpen, setResultModalOpen] = useState(false);

  useEffect(() => {
    const fetchCatalog = async () => {
      try {

        const richiesta = {
          BearerToken: sessionStorage.getItem("token"),
          username: sessionStorage.getItem("username"),
          //caseType: CASE_TYPE.CATALOG_ALL,
        }
        const options = {

          headers: {
            'Content-Type': 'application/json',
          }
        }


        const urlFetch = `${react_api}/privateResults/getCatalogADP`;

        const response = await axiosInstance.post(urlFetch, richiesta, options);

        const result = response.data;
        if (result.status === HTTP_STATUS_CODES.BAD_REQUEST || result.status === HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR) {
          toast({
            title: t('toastMsg.error'),
            description: t(`messageBE.${result.message}`),
            position: "top",
            status: 'error',
            duration: 4000,
            isClosable: true
          });
        }
        if (result.status === HTTP_STATUS_CODES.OK) {
          setCatalog(result.catalog)
        }

        else {
          toast({
            title: t('toastMsg.results.emptyResultsTable'),
            description: String(t(`messageBE.${result.message}`)),
            position: "top",
            status: 'info',
            duration: 4000,
            isClosable: true
          });
          setMessage(result.message);
        }
      } catch (error) {
        toast({
          title: t('toastMsg.callError'),
          description: String(error),
          position: "top",
          status: 'warning',
          duration: 4000,
          isClosable: true
        });
      }
    };
    fetchCatalog();
  }
    , []);

  const closeResultModal = () => {
    setResultModalOpen(false);
  };
  const openResultModal = (response, tableName) => {

    setKeys(Object.keys(response.previewTable[0]))
    setResultList(response.previewTable);
    setResultTableName(tableName);
    setSpinnerLoading(false);
    setResultModalOpen(true);
  };

  const visualizzaResult = async (tableName) => {
    try {
      setSpinnerLoading(true);
      const richiesta = {
        BearerToken: sessionStorage.getItem("token"),
        username: sessionStorage.getItem("username"),
        tableName: tableName
      }
      const options = {

        headers: {
          'Content-Type': 'application/json',
          'Authorization': sessionStorage.getItem('token')
        }

      }

      const urlFetch = `${react_api}/getTableADP`;

      const response = await axiosInstance.post(urlFetch, richiesta, options);

      const result = response.data;
      if (result.status === HTTP_STATUS_CODES.OK) {
        openResultModal(result, tableName)
      }

    } catch (error) {
      setSpinnerLoading(false);
      toast({
        title: t('toastMsg.results.processingViewFailed'),
        description: String(error),
        position: "top",
        status: 'warning',
        duration: 4000,
        isClosable: true
      });
    }
  }




  const publishResultADP = async (body) => {
    try {
      setSpinnerLoading(true)

      const options = {

        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': sessionStorage.getItem("token")
        }
      }
      const formData = new FormData();
      Object.keys(body).forEach((key) => {
        formData.append(key, body[key]);
      });

      const urlFetch = `${react_api}/privateResults/publishResultADP`;

      const response = await axiosInstance.post(urlFetch, formData, options);

      const result = response.data;

      if (result.status === HTTP_STATUS_CODES.OK) {

        setSpinnerLoading(false)
        return result;
      }

      else {
        setSpinnerLoading(false)
        toast({
          title: t('toastMsg.results.publishResultsError'),
          description: String(result.message),
          position: "top",
          status: 'info',
          duration: 4000,
          isClosable: true
        });
        setMessage(result.message);
      }
    } catch (error) {
      setSpinnerLoading(false)
      toast({
        title: t('toastMsg.callError'),
        description: String(error),
        position: "top",
        status: 'warning',
        duration: 4000,
        isClosable: true
      });
    }
  };

  return (
    <>
      {spinnerLoading && (
        <SpinnerXL />
      )}
      <Box alignItems={"center"} justifyContent={"space-between"} display={"flex"} color={"rgba(11,78,90,255)"} bgColor={"#f6f3ec"}>
        <Heading>{t('catalog.results.myResults')}</Heading></Box>
      <Box bgColor={"white"} overflowY="auto" direction="column" h="100%" w="100%" boxShadow="lg">
        <TableContainer px={"1%"} paddingTop={"1%"} >

          <Table variant='striped'>

            <Thead bgColor={"#0888BE"}>
              <Tr>
                {/* <Th  whiteSpace={"normal"} wordBreak={"break-word"} color={"white"}>Id</Th> */}
                <Th whiteSpace={"normal"} wordBreak={"break-word"} color={"white"}>Dataset</Th>
                <Th whiteSpace={"normal"} wordBreak={"break-word"} color={"white"}>{t('catalog.results.table.creationDate')}</Th>
                <Th whiteSpace={"normal"} wordBreak={"break-word"} color={"white"}>{t('catalog.results.table.actions')}</Th>
              </Tr>
            </Thead>


            <Tbody>
              {catalog.length > 0 ? (
                (catalog.map((item, index) => (
                  <Tr>
                    {/* <Td whiteSpace={"normal"} wordBreak={"break-word"}>{item.tableId}</Td> */}
                    <Td whiteSpace={"normal"} wordBreak={"break-word"}>{item.tableName}</Td>
                    <Td whiteSpace={"normal"} wordBreak={"break-word"}>{convertUtcToLocal(item.createTime)}</Td>
                    <Td>
                      <HStack align={"center"} wrap="wrap">
                        <Tooltip label={t('toolTip.tooltipMyResults.resultView')} placement="left" closeOnClick={true}>
                          <Icon as={SearchIcon} onClick={() => visualizzaResult(item.tableName)} _hover={{ color: "#0888BE" }} />
                        </Tooltip>
                        {/* <Tooltip label={t('toolTip.tooltipMyResults.publishResult')} placement="bottom" closeOnClick={true}>
                          <Icon as={BsFillSendPlusFill} onClick={() => { setPublishResultPayload({ ...publishResultPayload, ["tableName"]: item.tableName }); onPublishResultModalOpen() }} _hover={{ color: "#0888BE" }} />
                        </Tooltip> */}

                      </HStack>
                    </Td>
                  </Tr>)))) : (<Tr><Text fontSize={"lg"} fontWeight={"bold"}>{message ? t(`messageBE.${message}`) : ''}</Text></Tr>)}
            </Tbody>
          </Table>

        </TableContainer></Box>


      <Modal onClose={closeResultModal} isOpen={isResultModalOpen} isCentered closeOnOverlayClick={false} >
        <ModalOverlay />
        <ModalContent maxW="60%" h="50%">
          <ModalHeader bgColor={"#0888BE"} color="yellowgreen" display="flex" justifyContent="space-between"><Box>Result view: <Text fontSize={"lg"} fontWeight={"bold"} color="white">{resultTableName}</Text></Box><Box><CloseButton onClick={closeResultModal} /> </Box></ModalHeader>
          <ModalBody overflow={"auto"} h={"100%"}>
            <Box   >
              <Table variant="striped" size={"sm"} h={"90%"} w="100%">
                <Thead bgColor={"#0888BE"} position={"sticky"}>
                  <Tr>
                    {keys ? (
                      keys.map((key) => (
                        <Th color="white" key={key}>{key}</Th> // Renderizza le chiavi come intestazioni di colonna
                      ))) : ("")}
                  </Tr>
                </Thead>
                <Tbody>
                  {resultList.length > 0 ?
                    (resultList.map((item, index) => (
                      <Tr key={index}>
                        {keys.map((key) => (
                          <Td key={key}>{item[key]}</Td> // Renderizza il valore corrispondente alla chiave
                        ))}
                      </Tr>
                    ))) : ("")}
                </Tbody>
              </Table></Box>
          </ModalBody>
        </ModalContent>
      </Modal>


      <Modal isOpen={isPublishResultModalOpen} onClose={onPublishResultModalClose} isCentered size={"xl"} closeOnOverlayClick={false}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader bgColor={"#0888BE"} color={"white"}>{t('catalog.results.publishResult')}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl>
              <FormLabel>{t('catalog.results.newTableName')}</FormLabel>
              <Input
                placeholder={t('catalog.results.newTableName')}
                onChange={(e) => setPublishResultPayload({ ...publishResultPayload, ["newTableName"]: e.target.value })}
              />
            </FormControl>

            <FormControl mt={4}>
              <FormLabel>{t('catalog.results.title')}</FormLabel>
              <Input
                placeholder={t('catalog.results.title')}
                onChange={(e) => setPublishResultPayload({ ...publishResultPayload, ["title"]: e.target.value })}
              />
            </FormControl>




            <FormControl mt={4}>
              <FormLabel>{t('catalog.results.externalVersion')}</FormLabel>
              <Input
                placeholder={t('catalog.results.externalVersion')}
                onChange={(e) => setPublishResultPayload({ ...publishResultPayload, ["externalVersion"]: e.target.value })}
              />
            </FormControl>

          </ModalBody>

          <ModalFooter>
            <Button colorScheme='green' mr={3} onClick={() => {






              publishResultPayload.username = sessionStorage.getItem("username");

              publishResultADP(publishResultPayload).then((res) => {
                console.log(res)
              })


            }}>
              {t('catalog.results.publishResult')}
            </Button>
            <Button variant="ghost" onClick={onPublishResultModalClose}>
              {t('catalog.results.cancel')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

    </>


  )
}


